import React from 'react'
import AprueboRechazo from '@/components/AprueboRechazo'
import ltvoto from '@/images/lt-voto.svg'
import styled from 'styled-components'
import tw from 'tailwind.macro'

const Info = styled.div`
  ${tw`mt-8 bg-white p-4`}
  .lticon {
    ${tw`w-8 mx-auto mb-2`}
  }
`

const CajaVotacion = ({ apruebo, rechazo, children }) => {
  return (
    <Info>
      <img className="lticon" src={ltvoto} />

      <div>{children}</div>
      <AprueboRechazo apruebo={apruebo} rechazo={rechazo} />
    </Info>
  )
}

export default CajaVotacion
